import { useTranslate } from "@/utils/i18n";

interface AppSkeletonProps {
  message?: string;
}

export function AppSkeleton({ message }: AppSkeletonProps) {
  const t = useTranslate();

  return (
    <div className="w-full h-screen flex flex-col items-center justify-center bg-background gap-4">
      {/* Logo placeholder with pulse animation */}
      <div className="w-16 h-16 bg-primary/20 rounded-full animate-pulse" />

      {/* Loading spinner */}
      <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary" />

      {/* Loading message */}
      <p className="text-sm text-muted-foreground animate-pulse">{message || t("app.appSkeleton.initializing")}</p>
    </div>
  );
}
